/**
 * 時間の同期がされているかどうか、タイムゾーン別に管理するためのクラス
 */
export default class SyncStore {

    constructor() {
        /**
         * TimeZone => TimeStr
         * @type {Map<String,String>}
         */
        this.map = new Map();
    }

    /**
     * 指定タイムゾーンがシンクされているか判定
     *
     * @param zoneName {String}
     * @param timeStr {String}
     * @returns {boolean}
     */
    synced(zoneName, timeStr) {
        console.log("synced", zoneName, timeStr);
        let ret = this.map.get(zoneName);
        if (ret == null) {
            return false;
        }

        return ret === timeStr
    }


    /**
     * 同期されたときの情報をセット
     *
     * @param map {Map<String,String>}
     */
    sync(map) {
        console.log("sync", map);

        this.map = map;
    }
}

